
import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { ScheduledCouponsTable } from "@/components/campaigns/ScheduledCouponsTable";

const ScheduledCoupons = () => {
  return (
    <div className="container mx-auto p-6 space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Cashback Agendado</h1>
          <p className="text-muted-foreground">
            Visualize e monitore todo o cashback agendado do sistema
          </p>
        </div>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Todo o Cashback Agendado</CardTitle>
        </CardHeader>
        <CardContent>
          <ScheduledCouponsTable />
        </CardContent>
      </Card>
    </div>
  );
};

export default ScheduledCoupons;
